import { useEffect, useMemo, useState } from "react";
import { type FeatureFlagReadDto } from "@/config/apiClient";
import { type FeatureEnum } from "@/config/apiClient.types";
import { useFeatureFlags } from "./queries/useFeatureFlags";

export const useGetIsFeatureActive = (
  feature: FeatureEnum
): {
  isActive: boolean;
  isLoading: boolean;
  metadata: FeatureFlagReadDto["metadata"];
} => {
  const [isLoading, setIsLoading] = useState(true);

  const { useGetFeatureFlags } = useFeatureFlags();
  const {
    data: featureFlags,
    isLoading: isLoadingFeatureFlags,
    isFetching: isFetchingFeatureFlags,
  } = useGetFeatureFlags();

  useEffect(() => {
    if (isLoadingFeatureFlags) {
      setIsLoading(isLoadingFeatureFlags);
    }
    if (isFetchingFeatureFlags) {
      setIsLoading(isFetchingFeatureFlags);
    } else {
      setIsLoading(false);
    }
  }, [isLoadingFeatureFlags, isFetchingFeatureFlags]);

  const isActive = useMemo(
    () =>
      Boolean(featureFlags?.data?.find) &&
      Boolean(
        featureFlags?.data?.find(
          (featureFlag) => featureFlag.feature === feature
        )?.isActive
      ),
    [featureFlags, feature]
  );

  const metadata = useMemo(
    () =>
      featureFlags?.data?.find((featureFlag) => featureFlag.feature === feature)
        ?.metadata,
    [featureFlags, feature]
  );

  return { isActive, isLoading, metadata };
};
